export default __webpack_public_path__ + "static/media/cloud-computing.8a615fab.svg";